module.exports = __webpack_public_path__ + "media/src/img/line-progr-fe0afdc950ba9220fe2510267413d190.svg";